import React from 'react'

export const TsHintText = () => (
  <>
    ТЯГАЧ / ПРИЦЕП
    <br />
    <ul>
      <li>СТС</li>
    </ul>
  </>
)

export default TsHintText
